import React from 'react';

import GetTouchSection from '../GetTouchSection/GetTouchSection';



const Contactpage = () => {

    return (
        <div>

            <section className="wpo-contact-page section-padding pb-0">
                <div className="container">
                    <div className="office-info">
                        <div className="row">
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item h-100">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-location-1"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>address</h2>
                                        <p>Bay 6, 200 blackshaws road Altona north, Victoria</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item h-100">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-phone-call"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Phone Number</h2>
                                        <p>1300 100 868 </p>
                                        <p>1800 433 700 </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-4 col-md-6 col-12">
                                <div className="office-info-item h-100">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-email"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Email Us</h2>
                                        <p>info@ofllogistics.com</p>
                                        <p>sales@overflowsolutions.com.au</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contact-wrap">
                        <div className="row">
                            {/* <div className="col-lg-6 col-12">
                                <div className="contact-left">
                                    <h2>Get in touch</h2>
                                    <p>
                                        Let’s connect! Reach out to discuss your freight, warehouse, or transport requirements, and our experts will provide the right solution for your business.
                                    </p>
                                    <img className="image" src={Img01} alt="" />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="contact-right">
                                    <div className="title">
                                        <h2>Fill Up The Form</h2>
                                        <p>
                                            Share your information and let us know how we can help. Once submitted, our team will respond quickly with personalized support.
                                        </p>
                                    </div>

                                    <ContactForm />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <GetTouchSection />
            </section >

        </div >
    )


}

export default Contactpage;
